export const API_TYPES = {
  placement: "placement",
  workplace: "workplace",
  workplaceUser: "workplace-user",
  adminUser: "admin-user",
  worker: "worker",
  signedAgreement: "signed-agreement",
  placementCandidate: "placement-candidate",
  placementApplicant: "placement-applicant",
  placementApplication: "placement-application",
  placementProspect: "placement-prospect",
  license: "license",
  document: "document",
  credential: "credential",
  placementApplicationSummary: "placement-application-summary",
  chatChannel: "chat-channel",
  interviewSettings: "interview-settings",
  interviewAvailabilityException: "interview-availability-exception",
  passportPdfDownload: "passport-pdf-download",
  shift: "shift",
  shiftTimeProposal: "shift-time-proposal",
  workerLeftEarlyRequest: "worker-left-early-request",
  placementCandidateExclusion: "placement-candidate-exclusion",
  placementCandidateBan: "placement-candidate-ban",
  interviewAvailability: "interview-availability",
  interview: "interview",
  interviewCalendar: "interview-calendar",
  facilityUserInternalNotes: "facility-user-internal-notes",
  shiftOffer: "shift-offer",
  shiftOfferEstimate: "shift-offer-estimate",
  accessWindow: "access-window",
  openHouse: "open-house",
  adminOpenShift: "admin-open-shift",
  hiringEvent: "hiring-event",
  chartingCompletionReport: "charting-completion-report",
  chartingNoncompliance: "charting-noncompliance",
  shiftFeedback: "shiftFeedback",
  workerCredential: "worker-credential",
  workerRequirement: "worker-requirement",
  requirement: "requirement",
  trip: "trip",
  supportArticle: "support-article",
  shiftLog: "shift-log",
  presignedUrl: "presigned-url",
  transparencyPayRate: "transparency-pay-rate",
  shiftQualificationPricingSettings: "shift-qualification-pricing-settings",
  tag: "tag",
  documentDownload: "document-download",
  claimWorkplacePlacement: "claim-workplace-placement",
  externalIntegrationSyncRuns: "external-integration-sync-runs",
  interviewAttendanceVerification: "interview-attendance-verification",
  prerequisiteAction: "prerequisite-action",
  externalWorkplacePhoto: "external-workplace-photo",
  externalWorkplacePhotoScraping: "external-workplace-photo-scraping",
  externalPhotoPendingWorkplace: "external-photo-pending-workplace",
} as const;
